<template>
  <div class="editor">
    <input ref="input"
           type="file"
           class="file-input"
           @change="checkFile"
           style="display:none">
    <quill-editor :options="editorOption"
                  v-model="content"
                  @change="onEditorChange"></quill-editor>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor' //调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import quillConfig from '@/utils/quill-config.js'
import api from '@/servies/api'
import axios from 'axios'

export default {
  components: {
    quillEditor
  },
  data() {
    return {
      content: '',
      editorOption: quillConfig,
      fileList: []
    }
  },
  props:{
    defaultContent:{
      type:String,
    }
  
  },
  mounted() {
    this.content = this.defaultContent
    quillConfig.initButton()
  },
  methods: {
    onEditorChange() {
      this.$emit('change', this.content)
    },
    //上传文件
    checkFile(e) {
      this.$emit('changeFile',e)
    }
  }
}
</script>

<style lang="scss">
.editor {
  .ql-toolbar {
    border: 1px #e6e3e3 solid;
    border-left: 0px;
    border-right: 0px;
  }
  .ql-container {
    border: 0px;
    height: 443px;
  }
}
</style>

